var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationRecentsearch = function SvgGeneralInformationRecentsearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M5.121 13.606a6.006 6.006 0 0 1 0-8.484 5.96 5.96 0 0 1 4.243-1.758c1.603 0 3.11.624 4.242 1.758a5.96 5.96 0 0 1 1.758 4.242 5.96 5.96 0 0 1-1.758 4.242 5.96 5.96 0 0 1-4.242 1.758 5.96 5.96 0 0 1-4.243-1.758M20.47 19.94l-6.08-6.08A6.745 6.745 0 0 0 4.59 4.59a6.75 6.75 0 0 0 4.773 11.523c1.61 0 3.216-.58 4.494-1.726l6.08 6.08z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralInformationRecentsearch;